import { FEATURES } from './globals';

export const isExchangeMaxLimitEnabled = () =>
  FEATURES.SSJ_UI_EXCHANGE_MAX_LIMIT === true;

export default {
  isExchangeMaxLimitEnabled,
};
